import Axios from 'axios';
import Vue from 'vue';
import { joinPaths } from '@/utils/join-path';
import Store from '@/store';
import * as Message from '@/lib/message';
import EventBus from '@/lib/events';

const baseUrl = process.env.VUE_APP_BASE_URL;

const ServiceSubPathMap = new Map([
  ['biz', '/biz/api'],
  ['oxpecker', '/oxpecker/api'],
]);

export function request(options) {
  const { custom = {}, ...config } = options || {};
  const { service = 'oxpecker', responseOrigin = false, manualHandleError = false } = custom;

  const subPath = ServiceSubPathMap.get(service);

  const instance = Axios.create({
    baseURL: joinPaths(baseUrl, subPath),
    contentType: 'application/json',
    ...config,
  });

  instance.interceptors.request.use(async (config) => {
    const token = await Vue.prototype.$auth?.session?.getToken();

    const locale = Store.getters['common/locale'];

    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }

    if (locale) {
      config.headers.set('X-User-Language', locale);
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      if (responseOrigin) {
        return response;
      }

      return response.data;
    },
    (error) => {
      const { response } = error;
      const { data = {}, statusText, status } = response || {};

      if (response && !manualHandleError) {
        const { errMsg, detail } = data;

        if (statusText === 'Unauthorized' || status === 401) {
          EventBus.$emit('logout');
        }

        Message.error(detail || errMsg || statusText);
      }

      const errorInfo = {
        errMsg: statusText,
        ...(typeof data === 'object' ? data : {}),
      };

      return Promise.reject(errorInfo);
    }
  );

  return instance;
}

export function get(url, data, options) {
  return request(options).get(url, { params: data });
}

export function post(url, data, options) {
  return request(options).post(url, data);
}

export function put(url, data, options) {
  return request(options).put(url, data);
}

export function del(url, data, options) {
  return request(options).delete(url, { data });
}

export function patch(url, data, options) {
  return request(options).patch(url, data);
}
